import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useGenerateApiKey(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation<"post", "/shops/{shopId}/api/token", void>(
		"post",
		"/shops/{shopId}/api/token",
		{
			invalidate: invalidateShop,
			mapVariables: () => ({
				params: { path: { shopId: shop.id } },
			}),
		},
	);
}
